module.exports = __webpack_public_path__ + "static/optimize-img-1-845cb2c2ee303b7d34605a65d47bed5c.jpg";